import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import axios from 'axios';
import paths from 'routes/paths';
import { UPDATE_REQUIRED_KEY } from 'helpers/appUpdate';
import { useAppContext } from '../../providers/appProvider';
import { useTranslation } from 'react-i18next';
import { disconnectSocket } from 'assets/js/common';

export default function AppUpdateModal() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { setLocations, changeLocation } = useAppContext();
    const handledRef = useRef(false);

    useEffect(() => {
        const interval = setInterval(() => {
            const isUpdateRequired =
                sessionStorage.getItem(UPDATE_REQUIRED_KEY) === 'true';

            if (isUpdateRequired && !handledRef.current) {
                handledRef.current = true; // block re-entry
                clearInterval(interval);
                Swal.close();

                toast.info(
                    t('releaseTitle'),
                    {
                        position: 'top-right',
                        autoClose: 5000,
                        closeOnClick: false,
                        pauseOnHover: false,
                        draggable: false,
                        className: 'bg-primary text-white',
                        progressClassName: 'bg-light'
                    }
                );

                setTimeout(async () => {
                    toast.dismiss();

                    const userId = localStorage.getItem('UserId');
                    let isValid = false;

                    if (userId) {
                        try {
                            const response = await axios.get(
                                `${process.env.REACT_APP_API_URL}/userRoute/validateSession/${userId}`,
                                {
                                    headers: { Authorization: process.env.REACT_APP_BasicAuthSecret },
                                    timeout: 10000,
                                }
                            );
                            isValid = response.data?.valid === true;
                        } catch (err) {
                            isValid = false;
                        }
                    }

                    if (isValid) {
                        // Keep the user logged in — do NOT touch localStorage/sessionStorage.
                        // Hard refresh to pick up the latest deployed version.
                        sessionStorage.removeItem(UPDATE_REQUIRED_KEY);
                        window.location.reload();
                    } else {
                        // Account no longer valid — log out as before.
                        disconnectSocket();
                        sessionStorage.clear();
                        localStorage.clear();

                        setLocations([]);
                        changeLocation(null);

                        navigate(paths.login, { replace: true });
                    }
                }, 5000);
            }

        }, 300);

        return () => clearInterval(interval);
    }, [navigate, setLocations, changeLocation, t]);

    return null;
}